import styled, { css } from 'styled-components';

import { type COLOR, mixins, textStyles } from '#@/shared/utils/styles';

export const Root = styled.div<{ $color: COLOR; $hasIcon: boolean }>`
  --size: 16px;

  color: ${({ $color }) => $color};
  background-color: ${({ $color }) => mixins.rgba($color, 0.1)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--size);
  height: var(--size);
  border-radius: calc(var(--size) / 2);

  ${({ $hasIcon }) =>
    !$hasIcon &&
    css`
      padding: calc(var(--size) / 4);
    `};
`;

export const Text = styled.div`
  ${textStyles.sectionTitle700}
`;
